const StudentWarningsConfig = () => {
  return (
    <>
      <p className="mb-4 mt-2">TO-DO</p>
    </>
  );
};

export default StudentWarningsConfig;
